module.exports = __webpack_public_path__ + "img/icon_english_gray.74fa3558.svg";